/**
 * Aerocivil aviation radar — client production rollout scope (Milestone A8).
 * @see docs/weather/aerocivil-production-rollout.md
 */

export const AEROCIVIL_PRODUCTION_ROLLOUT_SCOPES = new Set([
  "local",
  "staging",
  "production",
  "all",
]);

export function parseBooleanEnv(value, defaultValue = false) {
  if (value === undefined || value === null || value === "") {
    return defaultValue;
  }
  return String(value).trim().toLowerCase() === "true";
}

export function getAerocivilProductionRolloutConfig() {
  const scope = String(process.env.REACT_APP_AEROCIVIL_RADAR_PUBLIC_ROLLOUT_SCOPE || "staging")
    .trim()
    .toLowerCase();

  return {
    publicUiEnabled: parseBooleanEnv(
      process.env.REACT_APP_AEROCIVIL_RADAR_ENABLED,
      false
    ),
    scope: AEROCIVIL_PRODUCTION_ROLLOUT_SCOPES.has(scope) ? scope : "staging",
    rollbackEnabled: parseBooleanEnv(
      process.env.REACT_APP_AEROCIVIL_RADAR_ROLLBACK_ENABLED,
      true
    ),
  };
}

export function isAerocivilRolloutScopeAllowed(
  scope,
  { nodeEnv = process.env.NODE_ENV } = {}
) {
  const env = String(nodeEnv || "development").toLowerCase();

  if (scope === "all") {
    return true;
  }
  if (scope === "local") {
    return env === "development" || env === "test";
  }
  if (scope === "staging") {
    return env === "development" || env === "test" || env === "staging";
  }
  if (scope === "production") {
    return env === "production";
  }
  return false;
}

export function isAerocivilPublicRolloutAllowed(options = {}) {
  const config = getAerocivilProductionRolloutConfig();
  if (!config.publicUiEnabled) {
    return false;
  }
  return isAerocivilRolloutScopeAllowed(config.scope, options);
}
